import { render, staticRenderFns } from "./ModalSpreadProfile.vue?vue&type=template&id=286a2725&"
import script from "./ModalSpreadProfile.vue?vue&type=script&lang=js&"
export * from "./ModalSpreadProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports